import { get } from "lodash";

// export let url = "http://localhost:8080/";
export let url = "https://backend.skillserve.in/";







// User type routes
export const CREATE_USER_TYPE = url +"createUserType";
export const UPDATE_USER_TYPE = url + "updateUserType";
export const FETCH_ALL_USER_TYPES = url + "getAllUserTypes";
export const GET_SINGLE_USER_TYPE = url + "getSingleUserType/";
export const DELETE_USER_TYPE = url + "deleteUserType/";
export const GET_ALL_TRAINERS = url + "getAllTrainers";
export const FORGOT_PASSWORD = url + "forgot-password/";
export const RESET_PASSWORD = url + "reset-password";
// user routes 
export const CREATE_USER = url + "createUser";
export const UPDATE_USER = url + "updateUser";
export const FETCH_ALL_USERS = url + "getAllUsers";
export const GET_SINGLE_USER = url + "getSingleUser/";
export const DELETE_USER = url + "deleteUser/";

export const POST_LOGIN = url + "login"
export const LOGOUT_URL = "http://localhost:3000/login";


// Content routes 

export const GENERATE_PRE_SIGNED_URL = url + "generatePreSignedUrl";
export const GENERATE_DELETE_PRE_SIGNED_URL = url + "generateDeletePresignedUrl";
export const GENERATE_PRE_SIGNED_URL_FOR_ACCESS = url + "generatePresignedUrlForAccess";





export let url_online = "http://13.51.59.133";
// export let url_online = "https://4wq09l1k-5290.inc1.devtunnels.ms";
export const BACKEND_SPRING = false;
// let url_online = "http://192.168.0.184:8080";
// export const BACKEND_SPRING = true;



//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"
export const STUDENT_REGISTER = url_online + "/RegisterStudent";



// CATEGORY
export const CREATE_CATEGORY = url + "createCategory"
export const DELETE_CATEGORY = url + "deleteCategory/"
export const UPDATE_CATEGORY = url + "updateCategory"
export const FETCH_ALL_CATEGORY = url + "getAllCategory"

//SUB CATEGORY
export const CREATE_SUBCATEGORY = url + "createSubCategory"
export const DELETE_SUBCATEGORY = url + "deleteSubCategory/"
export const UPDATE_SUBCATEGORY = url + "updateSubCategory"
export const FETCH_ALL_SUBCATEGORY = url + "getAllSubCategory"
export const GET_ALL_SUBCATEGORY_BASED_ON_CATEGORY = url + "getAllSubCategoryBasedOnCategory";

// COURSE
export const CREATE_COURSE = url + "createCourse";
export const UPDATE_COURSE = url + "updateCourse";
export const FETCH_ALL_COURSES = url + "getAllCourses";
export const FETCH_SINGLE_COURSE = url + "getSingleCourse/";
export const DELETE_COURSE = url + "deleteCourse/";
export const DOWNLOAD_ASSESSMENT_QUESTION_DEMO_FILE = url + "assessmentQuestionDemoFile";
export const GET_QUESTION_BY_ASSESSMENT = url + "getQuestionByAssessment";
export const DOWNLOAD_COURSE_DETAILS_FILE = url + "courseDetailFile";
export const FETCH_COURSE_NAMES = url + "getAllCourseNames";

export const CREATE_SCORM_COURSE = url + "api/scorm/createCourse";
export const FETCH_ALL_SCORM_COURSES = url + "api/scorm/getAllCourses";
export const DELETE_SCORM_COURSE = url + "api/scorm/deleteCourse/";
export const LAUNCH_COURSE = url + "launch-scorm";
//IMAGE
export const FETCH_IMAGE = url + "fetchImage/";


// MODULE
export const CREATE_MODULE = url + "createModule";
export const UPDATE_MODULE = url + "updateModule";
// export const FETCH_ALL_MODULE__OF_COURSE = url + "getAllModuleOfCourse";
export const FETCH_SINGLE_MODULE = url + "getSingleModule/";
export const DELETE_MODULE = url + 'deleteModule/';

// LESSON
export const CREATE_LESSON = url + "createLesson";
export const UPDATE_LESSON = url + "updateLesson";
export const FETCH_ALL_LESSON__OF_MODULE = url + "getAllLessonOfModule";
export const FETCH_SINGLE_LESSON = url + "getSingleLesson/";
export const DELETE_LESSON = url + 'deleteLesson/';


// ASSESSMENT
export const CREATE_ASSESSMENT = url + "createAssessment";
export const DELETE_ASSESSMENT = url + "deleteAssessment/";


// Referral
export const REFER_COURSE = url + "referCourse";
export const GET_REFERRAL_BY_USER = url + "getReferralByUser";


// LEVEL
export const CREATE_LEVEL = url + "createLevel";
export const UPDATE_LEVEL = url + "updateLevel";
export const FETCH_ALL_LEVEL = url + "getAllLevel";
export const FETCH_SINGLE_LEVEL = url + "getSingleLevel/";
export const DELETE_LEVEL = url + 'deleteLevel/';

// Student
export const CREATE_STUDENT = url + "createStudent";
export const UPDATE_STUDENT = url + "updateStudent";
export const FETCH_ALL_STUDENTS = url + "getAllStudent";
export const FETCH_ALL_STUDENTS_FOR_TATA = url + "getAllStudentsForTata";
export const FETCH_SINGLE_STUDENT = url + "getSingleStudent/";
export const DELETE_STUDENT = url + "deleteStudent/";
export const STUDENT_DEMO_FILE = url + "studentDemoFile";
export const CREATE_STUDENT_FROM_FILE = url + "createStudentsFromFile";
export const FETCH_ALL_COURSE_OF_STUDENT = url + "getAllCourseOfStudent/";






// These need /api/ prefix
export const GET_HISTORIES_WITH_FILTERS = url + "api/student-training-history/filter";
export const GET_ALL_HISTORIES_WITH_FILTERS = url + "api/student-training-history/all";
export const GET_FILTER_VALUES = url + "api/student-training-history/filter-values";
export const GET_DISTINCT_STATES = url + "api/student-training-history/distinct/states";
export const GET_DISTINCT_DEPOTS = url + "api/student-training-history/distinct/depots";
export const GET_DISTINCT_COURSES = url + "api/student-training-history/distinct/courses";
export const GET_DISTINCT_SCORM_COURSES = url + "api/student-training-history/distinct/scorm-courses";
export const GET_DISTINCT_FAIL_PASS = url + "api/student-training-history/distinct/fail-pass";
export const GET_HISTORY_BY_ID = url + "api/student-training-history/";
export const GET_STUDENT_HISTORY = url + "api/student-training-history/student/";
export const GET_STUDENT_BATCH_HISTORY = url + "api/student-training-history/student/";
export const GENERATE_STUDENT_HISTORY = url + "api/student-training-history/generate/student";
export const GENERATE_BATCH_HISTORY = url + "api/student-training-history/generate/batch/";
export const GENERATE_ALL_HISTORY = url + "api/student-training-history/generate/all/";
export const DELETE_HISTORY = url + "api/student-training-history/";
export const DELETE_STUDENT_HISTORY = url + "api/student-training-history/student/";
export const EXPORT_HISTORY_EXCEL = url + "api/student-training-history/export/excel";
export const CHECK_HISTORY_EXISTS = url + "api/student-training-history/exists";
export const ADVANCED_SEARCH = url + "api/student-training-history/advanced-search";
export const SEARCH_BY_KEYWORD = url + "api/student-training-history/search";

// ============================
// AUTO GENERATE URLs - Add /api/
// ============================
export const AUTO_GENERATE_START = url + "api/student-training-history/auto-generate/start/";
export const AUTO_GENERATE_STOP = url + "api/student-training-history/auto-generate/stop";
export const AUTO_GENERATE_STATUS = url + "api/student-training-history/auto-generate/status";









// SDR Report URLs
export const SDR_REPORT = url + "api/sdr-report";
export const SDR_NEVER_ENROLLED = url + "api/sdr-report/never-enrolled";
export const SDR_STATES = url + "api/sdr-report/states";
export const SDR_DEPOTS = url + "api/sdr-report/depots";
export const SDR_COURSES = url + "api/sdr-report/courses";

// // SDR Report URLs
// export const SDR_REPORT = url + "api/sdr-report";
// export const SDR_NEVER_ENROLLED = url + "api/sdr-report/never-enrolled";
// export const SDR_STATES = url + "api/sdr-report/states";
// export const SDR_DEPOTS = url + "api/sdr-report/depots";
// export const SDR_COURSES = url + "api/sdr-report/courses";



// Training 
export const CREATE_TRAINING = url + "createTraining";
export const DELETE_TRAINING = url + "deleteTraining/";
export const FETCH_SINGLE_TRAINING = url + "getSingleTraining/";
export const UPDATE_TRAINING = url + "updateTraining";
export const FETCH_ALL_TRAINING = url + "getAllTraining";
export const FETCH_TRAINERS_WITH_TRAINING = url + "trainers/with-trainings";

// NEW: Add this line for monthly training fetch
export const GET_TRAININGS_BY_MONTH = url + "month";




// // Training 
// export const CREATE_TRAINING = url + "createTraining";
// export const DELETE_TRAINING = url + "deleteTraining/";
// export const FETCH_SINGLE_TRAINING = url + "getSingleTraining/";
// export const UPDATE_TRAINING = url + "updateTraining";
// export const FETCH_ALL_TRAINING = url + "getAllTraining";
// export const FETCH_TRAINERS_WITH_TRAINING = url + "trainers/with-trainings"

// // NEW: Add this line for monthly training fetch
// export const GET_TRAININGS_BY_MONTH = url + "month";



// Enrollment 
export const CREATE_ENROLLMENT = url + "createEnrollment";
export const UPDATE_ENROLLMENT = url + "updateEnrollment";
export const FETCH_ALL_ENROLLMENTS_OF_COURSE = url + "getAllEnrollmentsOfCourse/";
export const FETCH_SINGLE_ENROLLMENT = url + 'getSingleEnrollment/';
export const DELETE_ENROLLMENT = url + 'deleteEnrollment/';




// Batch
// export const CREATE_BATCH = url + "createBatch";
// export const UPDATE_BATCH = url + "updateBatch";
// export const FETCH_ALL_BATCHES = url + "getAllBatches";
// export const FETCH_ALL_BATCHES_OF_TRAINER = url + "getAllBatchesOfTrainer";
// export const FETCH_SINGLE_BATCH = url + 'getSingleBatch/';
// export const DELETE_BATCH = url + 'deleteBatch/';
// export const ADD_IMAGES = url + "addImages/";
// export const DOWNLOAD_IMAGES_ZIP_FILE = url + "downloadImageZipFile/"
// export const DELETE_IMAGE_FROM_S3 = url + "deleteImageFromS3";
// export const ADD_COURSE_TO_BATCH = url + "addCourseToBatch/";
// export const ADD_SCORM_COURSE_TO_BATCH = url + "addScormCourseToBatch/";
// export const FETCH_ALL_COURSE_OF_BATCH = url + "getAllCourseOfBatch/";
// export const FETCH_ALL_SCORM_COURSE_OF_BATCH = url + "getAllScormCourseOfBatch/";
// export const ADD_STUDENT_TO_BATCH = url + "addStudentToBatch/";
// export const ADD_MULTIPLE_STUDENTS_TO_BATCH = url + "addMultipleStudentsToBatch/{batchId}";
// export const FETCH_ALL_STUDENT_OF_BATCH = url + "getAllStudentOfBatch/";
// export const ADD_TRAINER_TO_BATCH = url + "addTrainerToBatch/";
// export const FETCH_ALL_TRAINER_OF_BATCH = url + "getAllTrainerOfBatch/";

// export const GET_ASSESSMENT_RESULT_OF_BATCH_STUDENT = url + "getAssessmentResultOfBatchStudent/";

// // ============================
// // EXCEL DOWNLOAD ENDPOINTS
// // ============================
// // export const DOWNLOAD_BATCH_DETAILS_FILE = url + "batchDetailFile";
// export const DOWNLOAD_BATCH_DETAILS_FILE_WITH_FILTER = url + "batchDetailFileWithFilter";
// // url_helper.js - Add new endpoint

// export const DOWNLOAD_CONSOLIDATED_SIMULATOR_REPORT = url + "simulator/consolidated-report"


// export const REMOVE_COURSE_FROM_BATCH = url + "removeCourseFromBatch/";
// export const REMOVE_SCORM_COURSE_FROM_BATCH = url + "removeScormCourseFromBatch/";
// export const REMOVE_STUDENT_FROM_BATCH = url + "removeStudentFromBatch/";
// export const REMOVE_TRAINER_FROM_BATCH = url + "removeTrainerFromBatch/";

// export const REMOVE_ALL_STUDENT_FROM_BATCH = url + "removeAllStudentsFromBatch/";
// export const REMOVE_ALL_TRAINER_FROM_BATCH = url + "removeAllTrainersFromBatch/";


// export const DOWNLOAD_BATCH_DETAILS_FILE = url + "batchDetailFile";
// export const DOWNLOAD_BATCH_STUDENT_FILE = url + "batchStudentDetailFile/";

// export const STUDENT_ADDED_NOTIFICATION = url + "studentAddedNotification/"
// export const TRAINING_COMPLETION_NOTIFICATION = url + "trainingCompletionNotification/";

// export const downloadBatchReport = url + "generateReport/"











// url_helper.js - Complete file based on backend controller


// ============================
// BATCH ENDPOINTS
// ============================
export const CREATE_BATCH = url + "createBatch";
export const UPDATE_BATCH = url + "updateBatch";
export const FETCH_ALL_BATCHES = url + "getAllBatches";
export const FETCH_ALL_BATCHES_OF_TRAINER = url + "getAllBatchesOfTrainer";
export const FETCH_SINGLE_BATCH = url + 'getSingleBatch/';
export const DELETE_BATCH = url + 'deleteBatch/';

// ============================
// IMAGES ENDPOINTS
// ============================
export const ADD_IMAGES = url + "addImages/";
export const DOWNLOAD_IMAGES_ZIP_FILE = url + "downloadImageZipFile/";
export const DELETE_IMAGE_FROM_S3 = url + "deleteImageFromS3";

// ============================
// COURSE ENDPOINTS
// ============================
export const ADD_COURSE_TO_BATCH = url + "addCourseToBatch/";
export const ADD_SCORM_COURSE_TO_BATCH = url + "addScormCourseToBatch/";
export const FETCH_ALL_COURSE_OF_BATCH = url + "getAllCourseOfBatch/";
export const FETCH_ALL_SCORM_COURSE_OF_BATCH = url + "getAllScormCourseOfBatch/";
export const REMOVE_COURSE_FROM_BATCH = url + "removeCourseFromBatch/";
export const REMOVE_SCORM_COURSE_FROM_BATCH = url + "removeScormCourseFromBatch/";

// ============================
// STUDENT ENDPOINTS
// ============================
// export const ADD_STUDENT_TO_BATCH = url + "addStudentToBatch/";
export const ADD_STUDENT_TO_BATCH = url + "addStudentToBatch/";
export const ADD_MULTIPLE_STUDENTS_TO_BATCH = url + "addMultipleStudentsToBatch/";
export const FETCH_ALL_STUDENT_OF_BATCH = url + "getAllStudentOfBatch/";
export const REMOVE_STUDENT_FROM_BATCH = url + "removeStudentFromBatch/";
export const REMOVE_ALL_STUDENT_FROM_BATCH = url + "removeAllStudentsFromBatch/";

// ============================
// TRAINER ENDPOINTS
// ============================
// export const ADD_TRAINER_TO_BATCH = url + "addTrainerToBatch/";
export const ADD_TRAINER_TO_BATCH = url + "addTrainerToBatch/";
export const FETCH_ALL_TRAINER_OF_BATCH = url + "getAllTrainerOfBatch/";
export const REMOVE_TRAINER_FROM_BATCH = url + "removeTrainerFromBatch/";
export const REMOVE_ALL_TRAINER_FROM_BATCH = url + "removeAllTrainersFromBatch/";

// ============================
// ASSESSMENT ENDPOINTS
// ============================
export const GET_ASSESSMENT_RESULT_OF_BATCH_STUDENT = url + "getAssessmentResultOfBatchStudent/";
// export const GET_EXAM_RESULT = url + "getExamResult/";

// ============================
// PROGRESS ENDPOINTS
// ============================
// export const UPDATE_PROGRESS = url + "updateProgress/";
// export const GET_STUDENT_PROGRESS = url + "getStudentProgress/";

// ============================
// NOTIFICATION ENDPOINTS
// ============================
export const STUDENT_ADDED_NOTIFICATION = url + "studentAddedNotification/";
export const TRAINING_COMPLETION_NOTIFICATION = url + "trainingCompletionNotification/";

// ============================
// EXCEL DOWNLOAD ENDPOINTS
// ============================
export const DOWNLOAD_BATCH_DETAILS_FILE = url + "batchDetailFile";
export const DOWNLOAD_BATCH_DETAILS_FILE_WITH_FILTER = url + "batchDetailFileWithFilter";
export const DOWNLOAD_BATCH_DETAILS_FILE_WITH_FULL_FILTERS = url + "batchDetailFileWithFilters";
export const DOWNLOAD_BATCH_STUDENT_FILE = url + "batchStudentDetailFile/";
export const downloadBatchReport = url + "generateReport/";
export const FETCH_ALL_BATCHES_WITH_FILTERS = url + "getAllBatchesWithFilters";

// ============================
// FILTER ENDPOINTS (NEW)
// ============================
export const FETCH_DISTINCT_STATES = url + "states";
export const FETCH_DISTINCT_DEPOTS = url + "depots";

// ============================
// SIMULATOR ENDPOINTS (NEW)
// ============================
// export const DOWNLOAD_CONSOLIDATED_SIMULATOR_REPORT = url + "simulator/consolidated-report";

// ============================
// SIMULATOR ENDPOINTS - MAKE SURE THIS IS DEFINED
// ============================
export const DOWNLOAD_CONSOLIDATED_SIMULATOR_REPORT = url + "simulator/consolidated-report";








// Feedback
export const CREATE_FEEDBACK = url + "createFeedback";
export const DELETE_FEEDBACK = url + "deleteFeedback/";
export const GET_ALL_FEEDBACK_OF_BATCH = url + "getAllFeedbackOfBatch/";
export const GET_ALL_RESPONSE_OF_FEEDBACK = url + "getAllResponseOfFeedback/";

// Driver Marking 
export const SAVE_DRIVER_MARKING_ASSESSMENT = url + "saveDriverMarkingAssessment";
export const GET_ALL_DRIVER_MARKING_ASSESSMENT_OF_BATCH = url + "getAllDriverMarkingAssessmentOfBatch/";

// Bronze Assessment Marking 
export const SAVE_Bronze_ASSESSMENT = url + "saveBronzeAssessment";
export const GET_ALL_Bronze_ASSESSMENT_OF_BATCH = url + "getAllBronzeAssessmentOfBatch/";

// Bronze Assessment URLs
export const SAVE_BRONZE_ASSESSMENT = "/bronze-assessment/create";
export const GET_ALL_BRONZE_ASSESSMENT_OF_BATCH = "/bronze-assessment/batch/";
export const GET_SINGLE_BRONZE_ASSESSMENT = "/bronze-assessment/";


// Silver Assessment Marking 
export const SAVE_Silver_ASSESSMENT = url + "saveSilverAssessment";
export const GET_ALL_Silver_ASSESSMENT_OF_BATCH = url + "getAllSilverAssessmentOfBatch/";

// Silver Assessment URLs
export const SAVE_SILVER_ASSESSMENT = "/silver-assessment/create";
export const GET_ALL_SILVER_ASSESSMENT_OF_BATCH = "/silver-assessment/batch/";
export const GET_SINGLE_SILVER_ASSESSMENT = "/silver-assessment/";



// Gold Assessment Marking 
export const SAVE_Gold_ASSESSMENT = url + "saveGoldAssessment";
export const GET_ALL_Gold_ASSESSMENT_OF_BATCH = url + "getAllGoldAssessmentOfBatch/";

// Gold Assessment URLs
export const SAVE_GOLD_ASSESSMENT = "/gold-assessment/create";
export const GET_ALL_GOLD_ASSESSMENT_OF_BATCH = "/gold-assessment/batch/";
export const GET_SINGLE_GOLD_ASSESSMENT = "/gold-assessment/";






// ============= SIMULATOR ROUTES =============

// Mark simulator records
export const MARK_SIMULATOR = url + "api/simulator/mark";
export const MARK_ALL_SIMULATOR = url + "api/simulator/mark-all";

// Get simulator records
export const GET_ALL_SIMULATOR = url + "api/simulator/batch/";
export const GET_SIMULATOR_STATISTICS = url + "api/simulator/statistics/";

// Delete simulator records
export const DELETE_SIMULATOR_RECORD = url + "api/simulator/record/";
export const DELETE_STUDENT_SIMULATOR = url + "api/simulator/student/";
export const DELETE_BATCH_SIMULATOR = url + "api/simulator/batch/";

// Export simulator excel
export const SIMULATOR_EXCEL = url + "api/simulator/excel/";








// // ============= SIMULATOR ROUTES =============
// //Mark simulator records
// export const MARK_SIMULATOR = url + "api/simulator/mark";
// export const MARK_ALL_SIMULATOR = url + "api/simulator/mark-all";

// // Get simulator records
// export const GET_ALL_SIMULATOR = url + "api/simulator/batch/";
// export const GET_SIMULATOR_RANGE = url + "api/simulator/batch/";
// export const GET_SIMULATOR_STATISTICS = url + "api/simulator/batch/";

// // Delete simulator records
// export const DELETE_SIMULATOR_RECORDS = url + "api/simulator/batch/";
// export const DELETE_STUDENT_SIMULATOR = url + "api/simulator/student/";
// export const DELETE_BATCH_SIMULATOR = url + "api/simulator/batch/";

// // Export simulator excel
// export const SIMULATOR_EXCEL = url + "api/simulator/excel/";




// ============= SIMULATOR URLS =============
// export const MARK_SIMULATOR = "/simulator/mark";
// export const MARK_ALL_SIMULATOR = "/simulator/mark-all";
// export const GET_ALL_SIMULATOR = "/simulator/batch/";
// export const GET_SIMULATOR_RANGE = "/simulator/batch/";
// export const GET_SIMULATOR_STATISTICS = "/simulator/statistics/";
// export const DELETE_SIMULATOR_RECORDS = "/simulator/delete/";
// export const DELETE_STUDENT_SIMULATOR = "/simulator/student/";
// export const DELETE_BATCH_SIMULATOR = "/simulator/batch/";
// export const SIMULATOR_EXCEL = "/simulator/download-excel/";







// Live Class 
export const CREATE_LIVE_CLASS = url + "createClass"
export const UPDATE_LIVE_CLASS = url + "updateClass"
export const DELETE_LIVE_CLASS = url + "deleteClass/"

// Module Progress
// Add these to your web url_helper.js file
export const GET_STUDENT_PROGRESS = url + "getStudentProgress/";
export const UPDATE_PROGRESS = url + "updateProgressForStudent/";
export const FETCH_ALL_MODULE__OF_COURSE = url + "getAllModuleOfCourse";
export const GET_ALL_COURSE_OF_STUDENT = url + "getAllCourseOfStudent/";








// dashboard data
export const GET_ADMIN_DASHBOARD_DATA = url + "getAdminDashboardData";
export const GET_TRAINER_DASHBOARD_DATA = url + "getTrainerDashboardData";
export const GET_CONTENT_MANAGER_DASHBOARD_DATA = url + "getContentManagerDashboardData";
export const GET_TATA_DASHBOARD_DATA = url + "getTataDashboardData"


// New URLs for filters
export const GET_ALL_DEPOTS = url + "getAllDepots";
export const GET_ALL_STATES =url + "getAllStates";
export const GET_ALL_DIVISIONS = url + "getAllDivisions";



// Attendance
export const MARK_STUDENT_ATTENDANCE = url + "markStudentAttendence";
export const MARK_ALL_STUDENT_ATTENDANCE = url + "markAllStudentAttendence";
export const MARK_TRAINER_ATTENDANCE = url + "markTrainerAttendence";
export const GET_ALL_STUDENT_ATTENDANCE = url + "getAllStudentAttendence";
export const GET_TRAINER_ATTENDANCE = url + "getTrainerAttendence";
export const STUDENT_ATTENDANCE_EXCEL = url + "studentAttendanceExcel/";
export const TRAINER_ATTENDANCE_EXCEL = url + "trainerAttendanceExcel/";


// Exam
export const CREATE_EXAM = url + "createExam";
export const GET_ALL_EXAM_OF_BATCH = url + "getAllExamOfBatch/";
export const DOWNLOAD_EXAM_REPORT = url + "downloadExamReport/";
export const DELETE_EXAM = url + "deleteExam/";
export const GET_RESULT = url + "getExamResult/"

// Add the new status update endpoint
// export const UPDATE_EXAM_STATUS = url + "updateExamStatus";
// Alternative endpoint
export const UPDATE_EXAM_STATUS = url + "updateStatus/";




// using .Net
export const CREATE_CLASS = url_online + "/CreateClass"
export const DELETE_CLASS = url_online + "/RemoveClass?Id="
export const UPDATE_CLASS = url_online + "/UpdateClass"
export const FETCH_ALL_CLASSES = url_online + "/GetClass"



// using .net 
export const CREATE_SECTION = url_online + "/CreateSection"
export const DELETE_SECTION = url_online + "/RemoveSection?Id="
export const UPDATE_SECTION = url_online + "/UpdateSection"
export const FETCH_ALL_SECTIONS = url_online + "/GetSection"
export const FETCH_ALL_SECTION_BY_COURSE = url_online + "/GetSectionByCourse"

// using .net 
export const CREATE_SUBSECTION = url_online + "/CreateSubSection"
export const DELETE_SUBSECTION = url_online + "/RemoveSubSection?Id="
export const UPDATE_SUBSECTION = url_online + "/UpdateSubSection"
export const FETCH_ALL_SUBSECTIONS = url_online + "/GetSubSection"
export const FETCH_ALL_SUBSECTION_BY_SECTION = url_online + "/GetSubSectionBySection"

// difficulty
// using .net
export const CREATE_DIFFICULTY = url_online + "/CreateDifficulty"
export const DELETE_DIFFICULTY = url_online + "/RemoveDifficulty?Id="
export const UPDATE_DIFFICULTY = url_online + "/UpdateDifficulty"
export const FETCH_ALL_DIFFICULTYS = url_online + "/GetDifficulty"


export const CREATE_LANGUAGE = url_online + "/AddLanguage"
export const DELETE_LANGUAGE = url_online + "/RemoveLanguage?Id="
export const UPDATE_LANGUAGE = url_online + "/UpdateLanguage"
export const FETCH_ALL_LANGUAGES = url_online + "/GetLanguages"





export const CREATE_QUESTION = url_online + "/CreateQuestion"
export const BULK_CREATE_QUESTION = url_online + "/BulkQuestionCreate"
export const DELETE_QUESTION = url_online + "/RemoveQuestion?Id="
export const UPDATE_QUESTION = url_online + "/UpdateQuestion"
export const FETCH_ALL_QUESTIONS = url_online + "/GetQuestions"
export const FETCH_SINGLE_QUESTION = url_online + "/GetSingleQuestions?Id=";
export const QUESTION_CSV_FILE_FORMAT = url_online + "/GetQuestionDemoFormat";
export const STUDENT_CSV_FILE_FORMAT = url_online + "/GetStudentDemoFormat";

// image 

export const IMAGE_FETCH = url_online + "/GetImage?imageName=";



// Question Paper
export const CREATE_QUESTIONPAPER = url_online + "/CreateQuestionPaper";
export const UPDATE_QUESTIONPAPER = url_online + "/UpdateQuestionPaper";
export const DELETE_QUESTIONPAPER = url_online + "/DeleteExamPaper?Id=";
export const FETCH_ALL_QUESTIONPAPERS = url_online + "/GetExamPapers";
export const FETCH_EXAM_PAPER = url_online + "/GetExamPapersById?Id=";
export const DELETE_QUESTION_FROM_PAPER = url_online + "/DeleteExamQuestion?PaperId=";
export const FETCH_FILTER_QUESTIONS = url_online + "/GetFilterQuestions";
export const ADD_QUESTION_TO_PAPER = url_online + "/AddQuestionToPaper";




// USER 
export const GET_USER_TYPE = url_online + "/GetUserType"
export const GET_OTP = url_online + "/GetOTP"
export const VERIFY_OTP = url_online + "/VerifyOTP"


// SCHOOL 
export const CREATE_SCHOOL = url_online + "/CreateSchool"
export const DELETE_SCHOOL = url_online + "/RemoveClass?Id="
export const UPDATE_SCHOOL = url_online + "/UpdateSchool"
export const FETCH_ALL_SCHOOL = url_online + "/GetAllSchools"
export const FETCHS_SCHOOL_TYPES = url_online + "/GetSchoolTypes"

export const UPLOAD_STUDENTS = url_online + "/BulkStudentUploads";
export const GET_ALL_STUDENT = url_online + "/GetAllStudents";
export const GET_STUDENTS_FOR_MAPPING = url_online + "/GetStudentsForMapping";
export const LOGIN_STUDENT = url_online + "/StudentLogin";


//Exam
export const SAVE_EXAM_ANSWERS = url_online + "/saveExamAnswers"
export const GET_EXAM_RESULT = url_online + "/GetExamResult?Id="
export const GET_RESULT_DETAILS1 = url_online + "/GetResultDetails?StudentId="
export const GET_RESULT_DETAILS2 = "&ExamPaperId="
export const SEND_EXAM_RESULT = url_online + "/SendExamResult?ExamPaperId="

// exam managment
export const FETCH_ALL_CENTERS = url_online + "/GetAllCenters";
export const CENTER_ALLOCATION = url_online + "/GetCenterAllocated";
export const TOTAL_SUTDENTS_CENTER_CAPACITY_COUNT = url_online + "/GetCountOfCenterStudents?PaperId=";
export const ALLOCATE_ROLL_NUMBER_AND_PASSWORD = url_online + "/AllocateRollNoAndPassword?PaperId=";
export const CREATE_MAIN_EXAM_PAPER = url_online + "/CreateMainExamPaper";
export const UPDATE_MAIN_EXAM_PAPER = url_online + "/UpdateMainExamPaper"
export const GET_ALL_MAIN_EXAM_PAPERS = url_online + "/GetMainExamPapers";
export const DELETE_MAIN_EXAM_PAPER = url_online + "/DeleteMainExamPaper?Id=";
export const GET_MAIN_EXAM_PAPERS_BY_LANGUAGE = url_online + "/GetExamPaperByLanguage?Id=";
export const ASSIGN_EXAM_TO_STUDENTS = url_online + "/AssignExamToStudents";

const url2 = "https://4wq09l1k-5290.inc1.devtunnels.ms"






//organization
export const CREATE_ORGANIZATION = url2 + "/CreateOrganization";
export const GET_ORGANIZATION_BY_ID = url_online + "/GetOrganizationById?Id=";
export const UPDATE_ORGANIZATION = url_online + "/UpdateOrganization";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats";
export const GET_GROUPS = "/groups";
export const GET_CONTACTS = "/contacts";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "/add/messages";
export const DELETE_MESSAGE = "/delete/message";

//TASKS
export const GET_TASKS = "/tasks";
export const DELETE_KANBAN = "/delete/tasks"
export const ADD_CARD_DATA = "/add/tasks"
export const UPDATE_CARD_DATA = "/update/tasks"